export const customStructuredClone = (obj: Record<any, any>) => {
	return JSON.parse(JSON.stringify(obj));
};
